import apiClient from "../apiClient";
import { MenuItem } from "./menu";

const baseUrl = '/system/roles'

export type RoleStatus = 'enabled' | 'disabled';

export type RoleItem = {
    _id: string;
    name: string;
    code: string;
    description?: string;
    status: RoleStatus;
    createdAt?: string;
    updatedAt?: string;
};

export async function getRoles(params: {
    current?: number;
    pageSize?: number;
    keyword?: string;
}) {
    return apiClient<{
        list: RoleItem[]; total: number;
    }>(baseUrl, {
        method: 'GET',
        params,
    });
}

export async function addRole(data: Partial<RoleItem>) {
    return apiClient(baseUrl, {
        method: 'POST',
        data,
    });
}

export async function updateRole(id: string, data: Partial<RoleItem>) {
    return apiClient(`${baseUrl}/${id}`, {
        method: 'PUT',
        data,
    });
}

export async function deleteRole(id: string) {
    return apiClient(`${baseUrl}/${id}`, {
        method: 'DELETE',
    });
}


const baseUrlMenu = `${baseUrl}/menus`
/** 该角色下的menus */
export async function getRoleMenus(params: {
    roleCode?: string;
}) {
    return apiClient<{
        list: MenuItem[]; total: number;
    }>(baseUrlMenu, {
        method: 'GET',
        params,
    });
}

// 绑定菜单
export async function addRoleMenus(data: { roleCode: string; menuIds: string[] }) {
    return apiClient(baseUrlMenu, {
        method: 'POST',
        data,
    });
}

/** 解除绑定 */
export async function deleteRoleMenus(data: { roleCode: string; menuIds: string[] }) {
    return apiClient(baseUrlMenu, {
        data,
        method: 'DELETE',
    });
}
